import { Chip, Divider, Stack, Typography } from "@mui/material";
import { FormDataConsumer, Identifier, useGetOne } from "react-admin";
import { Fragment } from "react";
import { SiteResourcesEnum } from "shared/enums/resourceMappings";
import { SiteType } from "shared/types";

const GroupAssociationDisplay = () => {
  return (
    <FormDataConsumer>
      {({ formData }) => {
        const groupIds: Identifier[] = formData?.group_ids || [];
        const singleGroupId: Identifier | undefined = formData?.group_id;

        const allGroupIds: Identifier[] = [...groupIds, ...(singleGroupId ? [singleGroupId] : [])].filter(Boolean);

        if (allGroupIds.length === 0) return null;

        return (
          <Stack direction="column" spacing={2} width="100%">
            <Typography variant="h6">Existing Group-Site Associations</Typography>
            <Typography variant="caption" color="info.main" sx={{ mt: 0 }}>
              These are the sites that are currently associated with the
              {allGroupIds.length > 1 ? " groups " : " group "}
              you selected.
            </Typography>
            {allGroupIds.map((id: Identifier) => (
              <Fragment key={id}>
                <Divider />
                <GroupAssociationItem groupId={id} />
              </Fragment>
            ))}
          </Stack>
        );
      }}
    </FormDataConsumer>
  );
};

const GroupAssociationItem = ({ groupId }: { groupId: Identifier }) => {
  const { data: group } = useGetOne(SiteResourcesEnum.Groups, { id: groupId });
  if (!group) return null;
  return (
    <Stack direction="row" spacing={2} width={"100%"}>
      <Typography sx={{ minWidth: "200px" }}>Group {group?.name}</Typography>
      <Stack direction="row" gap={1} flexWrap="wrap">
        {group?.sites.length === 0 ? (
          <Typography variant="caption">No sites associated with this group</Typography>
        ) : (
          group?.sites.map((site: SiteType) => <Chip key={site.id} label={`${site.id} - ${site.name}`} />)
        )}
      </Stack>
    </Stack>
  );
};

export default GroupAssociationDisplay;
